import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { merchantListRequest } from '../../../redux/merchant/merchant.action'
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";

const MerchantList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { merchantListSuccess, merchantListError } = useSelector(state => state.merchant)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.MERCHANT_LIST, true)
            fetchBusinessList()
        } else if (isLoggedInUserEmployee(user)) {
            fetchMerchantList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.MERCHANT_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.MERCHANT_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(merchantListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(merchantListError)) {
            setLoading(false)
        }
    }, [merchantListSuccess, merchantListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchMerchantList()
        }
    }, [selectedLocation])

    const fetchMerchantList = () => {
        setLoading(true)
        const data = {
            businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
            locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
        }
        dispatch(merchantListRequest(data))
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.SUPPLIES.ADD_MERCHANT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.ADD_MERCHANT, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const handleAddMerchantClick = () => {
        navigate(ROUTES.supplies.merchant.newMerchant)
    }

    const handleDetailClick = (item) => {
        navigate(ROUTES.supplies.merchant.detail, {
            state: item.merchantId
        })
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Merchants' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {!isNull(merchantListSuccess) && !isEmpty(merchantListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Contact Person</th>
                                <th scope="col" className="text-center">Contact Number</th>
                                <th scope="col" className="text-center">Contact Email</th>
                                <th scope="col" className="text-center">Address</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {merchantListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{element.contactPersonName}</td>
                                    <td className="text-center">{element.contactPersonNumber}</td>
                                    <td className="text-center">{element.contactPersonEmail}</td>
                                    <td className="text-center">{element.address}</td>
                                    <td className="text-center">
                                        <div className={element.isActive === true ? 'active' : 'in-active'}>{element.isActive === true ? 'Active' : 'In-Active'}</div>
                                    </td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleDetailClick(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(merchantListError) && <div className="content-error">{merchantListError.message}</div>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.SUPPLIES.ADD_MERCHANT) && <div className="vl-fab-container" onClick={() => handleAddMerchantClick()}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default MerchantList